import tw, { styled } from "twin.macro"

import { StyledButton, UnderlinedButton } from "../../Styled/Button"

export const Wrapper = styled.div`
  ${tw`relative`}
`

export const Panel = styled.div<LayoutProps>`
  ${tw`flex flex-row justify-between items-center px-2-4 md:px-0`}
  ${({ layout }) => (layout === "cartProduct" ? tw`mb-2-4 md:mb-4` : tw`mb-4-2 md:mb-6-2`)}
`

export const Title = styled.h3<LayoutProps>`
  ${tw`font-bold uppercase`}
  ${({ layout }) =>
    layout === "cartProduct"
      ? tw`text-16 leading-1.42 md:text-20 md:leading-1.5 tracking-4 md:tracking-10`
      : tw`text-20 md:text-35 leading-1.25 md:leading-1.28 tracking-2 md:tracking-3 max-w-20 md:max-w-40 `}
`

export const DesktopViewAll = styled(UnderlinedButton)`
  ${tw`hidden md:block mb-1-2`}
`

export const CardWrapper = tw.div`
  px-2-4 md:px-0
`

export const MobileViewAllWrapper = tw.div`
  px-2-4
`

export const MobileViewAll = styled(StyledButton)`
  ${tw`md:hidden mt-2-4`}
`

export const Prev = styled.button<LayoutProps>`
  ${({ layout }) => (layout !== "cartProduct" ? tw`md:-left-4-8 md:top-1/2 right-5-7 top-0-4` : tw`right-5-7 top-0-2`)}
  ${tw`absolute transform -translate-y-1/2 z-10`}
  &.swiper-button-disabled {
    ${tw`opacity-25`}
  }
  span {
    svg {
      ${tw`w-1-8 md:w-2-1 h-1-8 md:h-2-1`}
    }
  }
`

export const Next = styled.button<LayoutProps>`
  ${({ layout }) => (layout !== "cartProduct" ? tw`md:-right-4-8 md:top-1/2 right-2-1 top-0-4` : tw`right-2-1 top-0-2`)}
  ${tw`absolute transform -translate-y-1/2 z-10`}
  &.swiper-button-disabled {
    ${tw`opacity-25`}
  }
  span {
    svg {
      ${tw`w-1-8 md:w-2-1 h-1-8 md:h-2-1`}
    }
  }
`

export const SliderWrapper = tw.div`relative`

type LayoutProps = {
  layout?: "cartProduct" | "product" | "article" | "instagram"
}
